































import { Component, Inject, Watch, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";

// Types
import {
  ICProdProvProvider,
  ICProdProvProviderMethods,
  IContractProductProvisioningForm
} from "@/models/providers/contractProduct";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  }
})
export default class ManageConfigurationForm extends Mixins(
  HasValidation,
  Context
) {
  // Inject
  @Inject({ from: "cProdProvProvider" })
  public readonly $provisioningData!: () => ICProdProvProvider;

  public get provisioningData() {
    return this.$provisioningData();
  }

  @Inject({ from: "cProdProvProviderMethods" })
  public readonly $provisioningMethods!: ICProdProvProviderMethods;

  public get provisioningMethods() {
    return this.$provisioningMethods;
  }

  // Data
  public form = {
    provision_field_values: {}
  } as IContractProductProvisioningForm;
  public initialForm = {
    provision_field_values: {}
  } as IContractProductProvisioningForm;

  public isProcessing = false;

  public created() {
    this.initialiseForm();
    this.startBusListener();
  }

  public startBusListener() {
    this.$bus.$on("initialiseConfigurationForm", () => {
      this.initialiseForm();
    });
  }

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      await this.provisioningMethods.updateContractProductFieldsValues(
        this.newValues
      );
      await this.provisioningMethods.getContractProductFieldsValues(true);

      if (this.isAdmin) {
        this.$bus.$emit("refreshRequestTable");
      }
      this.$emit("updated");
      this.$bus.$emit("cProdProvider::reloadData");
      await this.$provisioningMethods.reloadData();
      this.initialiseForm();
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
    this.isProcessing = false;
  }

  public get newValues() {
    const newValues: any = _.omitBy(
      this.form.provision_field_values,
      (v, k) => {
        return this.initialForm.provision_field_values[k] === v;
      }
    );

    return {
      provision_field_values: this.provisioningData.cProdSetupFieldsConfirmed
        ? newValues
        : this.form.provision_field_values,
      ...(this.provisioningData.cProdSetupFieldsConfirmed
        ? {}
        : { confirm: true })
    };
  }

  public get isFormChanged(): boolean {
    return !_.isEqual(this.form, this.initialForm);
  }

  public initialiseForm() {
    _.forEach(this.provisioningData.contractProductFields, field => {
      this.$set(
        this.form.provision_field_values,
        `${field.name}`,
        _.get(
          _.find(this.provisioningData.contractProductFieldsValues, [
            "blueprint_field_id",
            field.id
          ]),
          "value",
          field.default_value
        )
      );
    });

    this.initialForm = _.cloneDeep(this.form);
  }

  public get canSave() {
    return this.isAdmin
      ? this.$userCan("update_product_provision_field_values")
      : this.$userCan("update_contract_product_provision_field_values");
  }

  public revertToInitialState() {
    this.form = _.cloneDeep(this.initialForm);
  }

  @Watch("isFormChanged")
  public onIsEnabledChange() {
    this.$emit("isEnabled", this.isFormChanged && this.canSave);
  }

  @Watch("isProcessing")
  public onIsProcessingChange() {
    this.$emit("isProcessing", this.isProcessing);
  }

  public beforeDestroy() {
    this.$bus.$off("initialiseConfigurationForm");
  }
}
